import { render, staticRenderFns } from "./modalDegustacaoDropdownHeader.vue?vue&type=template&id=2f3f994b&scoped=true&"
import script from "./modalDegustacaoDropdownHeader.vue?vue&type=script&lang=js&"
export * from "./modalDegustacaoDropdownHeader.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=2f3f994b&scoped=true&lang=css&"
import style1 from "./modalDegustacaoDropdownHeader.vue?vue&type=style&index=1&id=2f3f994b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f994b",
  null
  
)

export default component.exports